<template>
  <v-form>
    <v-row>
      <v-col cols="12" md="6">
        <gg-text-field outlined
                      autocomplete="nope"
                      label="Account Name"
                      v-model="username"
                      v-validate="{ required: true, regex: /^[a-zA-Z0-9\-\_\.]*$/ }"
                      name="Account Name"
                      :error-messages="errors.collect('Log In')">
          <template v-slot:append>
            <div v-if="!isMobileDevice" class="append-bg">
              <domain-select no-label
                             hide-details
                             flat
                             solo
                             v-model="domain"
                             prepend-inner-icon="mdi-at"
                             style="margin-top: 10px"></domain-select>
            </div>
          </template>
        </gg-text-field>
      </v-col>
      <v-col v-if="isMobileDevice" cols="12" class="py-0">
        <domain-select outlined
                       v-model="domain"
                       label="Select a Domain"
                       :prepend-inner="false"></domain-select>
      </v-col>
      <v-col cols="12" md="6">
        <gg-input-label>Password</gg-input-label>
        <compact-password outlined
                          autocomplete="new-password"
                          v-validate="'required|min:8'"
                          data-vv-name="password"
                          data-vv-as="Password"
                          :error-messages="errors.collect('password')"
                          with-generator
                          v-model="password"></compact-password>
      </v-col>
      <v-col cols="12" md="6" class="pt-0">
        <gg-btn :loading="loading" @click="submit">Create Account</gg-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import DomainSelect from '@/components/Common/DomainSelect'
import CompactPassword from '@/components/Common/password/CompactPassword'

export default {
  name: 'FtpAccountForm',
  components: {
    DomainSelect,
    CompactPassword,
  },
  data () {
    return {
      username: '',
      domain: '',
      password: '',
      quota: '0',
      loading: false,
    }
  },
  computed: {
    ...mapGetters(['hostingDomainsList']),
    isMobileDevice () {
      return this.$vuetify.breakpoint.name === 'xs'
    },
  },
  methods: {
    ...mapActions({
      addFtpAccount: 'ftp/addFtpAccount',
      getFtpAccountsList: 'ftp/getFtpAccountsList',
      reportError: 'reportError',
      reportSuccess: 'reportSuccess',
    }),
    reset () {
      this.username = ''
      this.password = ''
      this.domain = ''
      this.quota = '0'
      this.$nextTick(() => {
        this.$validator.reset()
      })
    },
    async submit () {
      const valid = await this.$validator.validateAll()
      if (!valid) return
      this.loading = true
      const payload = {
        user: this.username,
        pass: this.password,
        quota: this.quota,
        domain: this.domain,
        _username: this.$route.query.user,
      }
      try {
        await this.addFtpAccount(payload)
      } catch (e) {
        this.loading = false
        this.reportError(e)
      }
      this.loading = false
      this.reportSuccess(`FTP account "${this.username}@${this.domain}" successfully created.`)
      this.$emit('account-created')
      this.reset()
      try {
        await this.getFtpAccountsList(this.$route.query.user)
      } catch (e) {
        this.reportError(e)
      }
    },
  },
}
</script>
